import { css } from 'lit';

/**
 * The thin scrollbar every scrolling panel shares: a bar with no track and a
 * translucent white thumb, declared in the standard properties for Firefox
 * and Chrome and in the WebKit pseudo-elements for Safari. The browser sizes
 * a `thin` bar itself (about 10px in Chrome), so the 6px below is Safari's
 * alone: Chrome skips the pseudo-elements once `scrollbar-width` is set. Two
 * variants, one class each:
 *
 * - `scrollbar-thin`: the thumb is always shown. For the panels that scroll
 *   as a whole (help, menu, big message, the pickers, the phone chat).
 * - `scrollbar-thin-hover`: the thumb is transparent until the pointer is over
 *   the box. For the feeds that sit on the game (chat, game log, the debug
 *   popup), so the bar is not a permanent grey line beside the action. On a
 *   touch screen there is no hover, and the browser's own overlay bar shows.
 *
 * Usage: `static override styles = [tokens, scrollbarThin, css\`...\`];` with
 * `class="scrollbar-thin"` on the scrolling element. A component keeps its own
 * overflow, gutter and overscroll rules; only the bar's look is shared. The
 * score panel's table keeps its own wider bar with a visible track.
 */
export const scrollbarThin = css`
  .scrollbar-thin {
    scrollbar-width: thin;
    scrollbar-color: var(--color-overlay-strong) transparent;
  }

  .scrollbar-thin::-webkit-scrollbar {
    width: 6px;
    height: 6px;
    background: transparent;
  }

  .scrollbar-thin::-webkit-scrollbar-thumb {
    background: var(--color-overlay-strong);
    border-radius: var(--radius-xs);
  }
`;

export const scrollbarThinHover = css`
  .scrollbar-thin-hover {
    scrollbar-width: thin;
    scrollbar-color: transparent transparent;
  }

  .scrollbar-thin-hover:hover {
    scrollbar-color: var(--color-overlay-strong) transparent;
  }

  .scrollbar-thin-hover::-webkit-scrollbar {
    width: 6px;
    height: 6px;
    background: transparent;
  }

  .scrollbar-thin-hover::-webkit-scrollbar-thumb {
    background: transparent;
    border-radius: var(--radius-xs);
  }

  .scrollbar-thin-hover:hover::-webkit-scrollbar-thumb {
    background: var(--color-overlay-strong);
  }
`;
